import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const Container = styled.div`
  display: grid;
  grid-template-rows: 25px 1fr;
  text-align: center;
  height: 100%;
  overflow-y: hidden;
  color: ${props => props.theme.colors.color6b7786};
`
export const LoadingContainer = styled.div`
  height: 100%;
  justify-content: center;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const Contents = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))`
  padding: 5px;
  position: relative;
  overflow-y: auto;
  background: ${({ theme }) => theme.zds.colors.neutral1000};
  ${VerticalStyledScrollBar}

  table {
    width: 100%;
  }
  tr {
    width: 100%;
    display: grid;
    grid-template-columns: 50% 28% 22%;
    text-align: left;
    padding: 6px;

    td:first-child {
      font: normal normal bold 14px/22px Inter;
    }
    td {
      font: normal normal normal 14px/22px Inter;
    }
  }
  .header {
    height: 29px;
    border-radius: 5px;
    background: ${props => props.theme.colors.colorf3f5f9};

    margin-bottom: 9px;
  }
`

export const AlertMessage = styled.div`
  width: 100%;
  height: 100%;
  padding: 5px;
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    color: ${props => props.theme.colors.color6b7786};
    font-family: Inter;
    font-size: 12px;
    font-weight: 22px;
    text-align: center;
  }
`
